var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-client-table", {
    staticClass: "w-100 vue-custom-table no-pagination disclaimers-table",
    attrs: {
      data: _vm.documentForms,
      columns: _vm.formsTableColumns,
      options: _vm.options,
      name: "consentRequestsTable",
    },
    scopedSlots: _vm._u([
      {
        key: "select",
        fn: function (ref) {
          var row = ref.row
          return [
            row.type !== "link"
              ? _c("div", { staticClass: "form-group-checkbox" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            title: _vm.$t(
                              "application.messages.selectAllDisabledTooltip"
                            ),
                            disabled: _vm.isFormSubmissionDependant(row),
                          },
                          expression:
                            "{\n          title: $t('application.messages.selectAllDisabledTooltip'),\n          disabled: isFormSubmissionDependant(row)\n        }",
                        },
                      ],
                      staticClass: "pretty p-icon p-smooth p-curve",
                    },
                    [
                      _c("checkbox-section", {
                        attrs: {
                          name: "select",
                          disabled:
                            !_vm.isFormSubmissionDependant(row) ||
                            (row.applicantSelect &&
                              !_vm.selectedApplicants[row.formKey].all),
                          checked: _vm.isMortgageSelected(
                            row.mortgagesSelected
                          ),
                          label: _vm.$t("global.words.select"),
                          "hidden-label": "",
                        },
                        on: {
                          change: function (e) {
                            return _vm.handleSelectDocument(row, e)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "mortgage",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "form-group-checkbox" }, [
              _c("p", [_vm._v(_vm._s(_vm.getMortgageTitle(row.formKey)))]),
            ]),
          ]
        },
      },
      {
        key: "name",
        fn: function (ref) {
          var row = ref.row
          return [
            row.type === "link"
              ? _c(
                  "a",
                  {
                    staticClass: "text-primary bold d-block py-1",
                    attrs: { href: row.url, target: "_blank" },
                  },
                  [
                    _vm._v("\n      " + _vm._s(row.fullName) + "\n      "),
                    _c("i", {
                      staticClass: "fa fa-external-link ml-1",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _c("p", [_vm._v("\n      " + _vm._s(row.fullName) + "\n    ")]),
          ]
        },
      },
      {
        key: "actions",
        fn: function (ref) {
          var row = ref.row
          return [
            row.type !== "link"
              ? _c(
                  "div",
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.$t(
                                "application.messages.selectAllDisabledTooltip"
                              ),
                              disabled: _vm.isFormSubmissionDependant(row),
                            },
                            expression:
                              "{\n          title: $t('application.messages.selectAllDisabledTooltip'),\n          disabled: isFormSubmissionDependant(row)\n        }",
                          },
                        ],
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm print-pdf-btn btn-primary mr-3 mb-2",
                            attrs: {
                              type: "button",
                              disabled:
                                !_vm.isFormSubmissionDependant(row) ||
                                (row.applicantSelect &&
                                  _vm.selectedApplicants[row.formKey].value
                                    .length === 0),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handlePrint(row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-folder-open-o",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.print")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    row.editable
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm edit-pdf-btn btn-primary mb-2 text-capitalize",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-pencil",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("global.words.edit")) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    row.applicantSelect && _vm.isFormSubmissionDependant(row)
                      ? _c("applicant-select", {
                          attrs: {
                            id:
                              "applicant-select-" +
                              row.formKey +
                              "-" +
                              _vm.mortgageType,
                            disabled:
                              _vm.selectedApplicants[row.formKey].locked,
                            value: _vm.selectedApplicants[row.formKey].value,
                            placeholder: _vm.$tc(
                              "documents.selectApplicant",
                              2
                            ),
                            "auto-select-all-applicants": true,
                            "only-applicants-with-email": false,
                            "show-for-single-applicant": false,
                          },
                          on: {
                            change: function (e) {
                              return _vm.handleApplicantSelect(row, e)
                            },
                            total: function (e) {
                              return _vm.handleTotalApplicants(row, e)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }